import CidadeService from "@/services/CidadeService";

export const cidade = {
  namespaced: true,
  state: {
    cidade: {},
  },
  actions: {
    getCidadeOData({ commit }, payload) {
      return CidadeService.GetCidadeOData(payload).then(
        (cidade) => {
          return Promise.resolve(cidade);
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    },
  },
  mutations: {},
};

export default cidade;
